import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "a",
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "50",
  viewBox: "0 0 48.92 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M29.12,21.17L47.33,0h-4.32l-15.81,18.38L14.57,0H0l19.1,27.8L0,50h4.32l16.7-19.41,13.34,19.41h14.57l-19.81-28.83h0ZM23.21,28.04l-1.94-2.77L5.87,3.25h6.63l12.43,17.78,1.94,2.77,16.15,23.11h-6.63l-13.18-18.85h0Z",
      "fill-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }